let config;

if (process.env.NODE_ENV === 'production') {
    config = {
        WEB_URL: 'https://mket-2fa-prod.stockradars.co',
        API_URL: 'https://mket-proxy-prod.stockradars.co',
    };
} else {
    config = {
        WEB_URL: 'https://mket-2fa.stockradars.co',
        API_URL: 'https://mket-proxy-prod.stockradars.co',
    };
}

module.exports = config;

